import HomePage from "./components/homePage";
import Header from "./components/header";
import { Routes, Route } from "react-router-dom";
import Footer from "./components/footer";
import ContactForm from "./contact";
import { Helmet } from "react-helmet";
import HomeSecond from "./homesecond";

export default function Home() {
    return (
    <div className="relative bg-black text-white font-sans">

      <Helmet>
          <title>iFLO Pro | Home </title>
          <meta name="description" content="iFLO Pro is your ultimate solution for HVAC water damage prevention. Protect your property with our advanced water detection and prevention technology." />
          <meta name="keywords" content="iFLO, HVAC, water damage, prevention, technology, water detection, property protection, smart HVAC" />
          <meta name="robots" content="index, follow" />
          <meta property="og:title" content="iFLO Pro - HVAC Water Damage Prevention" />
          <meta property="og:description" content="Advanced water detection and prevention technology for HVAC systems. Protect your property with iFLO Pro." />
          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://iflopros.com" />
          <meta name="twitter:title" content="iFLO Pro - HVAC Water Damage Prevention" />
          <meta name="twitter:description" content="Advanced water detection and prevention technology for HVAC systems. Protect your property with iFLO Pro." />
          <script type="application/ld+json">
            {JSON.stringify({
              "@context": "https://schema.org",
              "@type": "Organization",
              "name": "iFLO Pro",
              "description": "Advanced water detection and prevention technology for HVAC systems",
              "url": "https://iflopros.com",
              "logo": "https://iflopros.com/logo.png",
              "sameAs": [
                "https://www.linkedin.com/company/iflopros",
              ],
              "contactPoint": {
                "@type": "ContactPoint",
                "telephone": "888-979-iFLO (4356)",
                "contactType": "customer service"
              }
            })}
          </script>
      </Helmet>
      {/* Announcement Bar */}
      <Header />

      <HomePage />
      
      <Footer />
    </div>
    );
}